<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="客户名称"
                        prop="keyword">
            <el-input placeholder="请输入客户名称"
                      v-model="search.keyword"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="false">
      <div class="margin b15">
        <router-link :to="'/customer-task/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                :height="$root.mainHeight - 150 +'px'"
                style="width: 100%">
        <el-table-column prop="number"
                         label="客户编号"
                         min-width="80">
        </el-table-column>

        <el-table-column label="客户名称">
          <el-table-column prop="name"
                           :label="platformHeader.name"
                           min-width="100">
            <template slot-scope="scope">
              <router-link :to="{path: '/customer-project/table/' + scope.row.id, query: {customername: scope.row.name}}">
                <span class="link">{{scope.row.name}}</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="总数">
          <el-table-column prop="total"
                           :label="String(platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0}})">
                {{platformHeader.total}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:scope.row['id']}})">
                {{scope.row.total}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="新创建">
          <el-table-column prop="0"
                           :label="getPercentData(platformHeader['0'], platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['0']}})">
                {{getPercentData(platformHeader['0'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task/table',query:{customerid:scope.row['id'],status:['0']}})">
                {{getPercentData(scope.row['0'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="等待抢单">
          <el-table-column prop="1"
                           :label="getPercentData(platformHeader['1'], platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['1']}})">
                {{getPercentData(platformHeader['1'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task/table',query:{customerid:scope.row['id'],status:['1']}})">
                {{getPercentData(scope.row['1'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="已抢单">
          <el-table-column prop="2"
                           :label="getPercentData(platformHeader['2'], platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['2']}})">
                {{getPercentData(platformHeader['2'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/order/table',query:{customerid:scope.row['id'],status:['2']}})">
                {{getPercentData(scope.row['2'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="进行中">
          <el-table-column prop="3"
                           :label="getPercentData(platformHeader['3'], platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['3','20']}})">
                {{getPercentData(platformHeader['3'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/order/table',query:{customerid:scope.row['id'],status:['3','20']}})">
                {{getPercentData(scope.row['3'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="待审核">

          <el-table-column prop="4"
                           :label="getPercentData(platformHeader['4'], platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['4']}})">
                {{getPercentData(platformHeader['4'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/order/table',query:{customerid:scope.row['id'],status:['4']}})">
                {{getPercentData(scope.row['4'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="审核未通过">
          <template slot="header"
                    slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        content="退单不允许修改的工单"
                        placement="bottom">
              <span>审核未通过</span>
            </el-tooltip>
          </template>
          <el-table-column prop="-2"
                           :label="getPercentData(platformHeader['-2'], platformHeader.total)"
                           min-width="100">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['-2']}})">
                {{getPercentData(platformHeader['-2'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/order/table',query:{customerid:scope.row['id'],status:['-2']}})">
                {{getPercentData(scope.row['-2'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="已关闭">
          <template slot="header"
                    slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        content="包含提交过&未提交的工单，可通过审核次数筛选"
                        placement="bottom">
              <span>已关闭</span>
            </el-tooltip>
          </template>
          <el-table-column prop="-1"
                           :label="getPercentData(platformHeader['-1'], platformHeader.total)">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['-1']}})">
                {{getPercentData(platformHeader['-1'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/order/table',query:{customerid:scope.row['id'],status:['-1']}})">
                {{getPercentData(scope.row['-1'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="审核通过">
          <template slot="header"
                    slot-scope="scope">
            <span>审核通过</span>
          </template>
          <el-table-column prop="5"
                           :label="getPercentData(platformHeader['5'], platformHeader.total)"
                           min-width="100">
            <template slot="header"
                      slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/task-order/table',query:{customerid:0,status:['5']}})">
                {{getPercentData(platformHeader['5'], platformHeader.total)}}
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                         @click="$router.push({path: '/order/table',query:{customerid:scope.row['id'],status:['5']}})">
                {{getPercentData(scope.row['5'], scope.row.total)}}
              </el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import { searchRules } from '../customer-task.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    let customerTypes = {
      10: 'customer',
      20: 'ee'
    }
    return {
      searchRules,
      search: {
        keyword: '',
        customer_type: customerTypes[this.$route.params.type] || customerTypes[10],
      },
      platformHeader: {
        name: '',
        total: '',
        '0': '',
        '1': '',
        '2': '',
        '3': '',
        '4': '',
        '-1': '',
        '-2': '',
        '5': '',
      },
      exportHeader: [
        {
          key: 'number',
          text: '客户编号',
        },
        {
          key: 'name',
          text: '客户名称',
        },
        {
          key: 'total',
          text: '总数',
        },
        {
          key: '0',
          text: '新创建',
        },
        {
          key: '1',
          text: '等待抢单',
        },
        {
          key: '2',
          text: '已分配',
        },
        {
          key: '3',
          text: '处理中',
        },
        {
          key: '4',
          text: '处理完成',
        },
        {
          key: '-1',
          text: '已关闭',
        },
        {
          key: '-2',
          text: '审核未通过',
        },
        {
          key: '5',
          text: '管理员确认',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions(['getCustomerTaskTable']),


    getTableData (params) {
      return request.page('getCustomerTaskTable', params)
    },


    setTableData ({data}) {
      this.platformHeader = data.data.platform

      this.$set(this, 'table', data.data.statistics)
      this.setPagination(data)
    },


    getPercentData (value = 0, total = 0) {
      return String(value) + `(${total === 0 ? 0 : Math.round(value / total * 100)}%)`
    },


    onExportSearch () {
      this.$export(this.$route.meta.title, {
        request: (params) => request('getCustomerTaskTable', {...this.search, ...params}),
        total: this.pagination.total,
        fileHeader: this.exportHeader,
        getResponseData: (data) => {
          const exportData = {
            data: [
              data.data.platform,
              ...data.data.statistics,
            ],
          }

          return Object.assign({}, data, exportData)
        },
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/customer-task/pages/CustomerTaskTable.vue